<template>
  <div class="ListSelection">
    <span class="ListSelection-selectAll">
      <ubi-icon name="arrow-down" v-if="arrowDown" class="ListSelection-arrowDown" />
      <el-checkbox
        :key="countSelected"
        v-model="countSelected"
        :indeterminate="!!countSelected || (this.value && this.value.length > 0)"
        @input="onCheckAll"
        v-else
      >
        <em></em>
      </el-checkbox>
    </span>
    <span class="ListSelection-options">
      <el-button
        class="ListSelection-option"
        v-if="!!countSelected"
        native-type="button"
        type="text"
        @click.prevent="onCheckAll(false)"
        >{{ $t("components.lists.eraseSelection") }}</el-button>
      <el-button
        class="ListSelection-option"
        v-else
        native-type="button"
        type="text"
        @click.prevent="onCheckAll(true)"
        >{{ $t("components.lists.selectAll") }}</el-button
      >
      <template v-for="({ value, label }, index) in selections">
        <el-divider direction="vertical" :key="index" />
        <el-button
          class="ListSelection-option"
          type="text"
          native-type="button"
          :key="value"
          v-text="label"
          @click.prevent="$emit('select', value)"
        />
      </template>
    </span>
  </div>
</template>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.ListSelection {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  @extend .mt-1;

  &-selectAll {
    .el-checkbox {
      @extend .mb-2;
    }
  }

  &-arrowDown {
    @extend .mr-2;
    display: inline-block;
    text-align: center;
    width: 22px;
  }

  &-options {
    @extend .mb-2;
  }

  &-option {
    @extend .p-0;
    color: $black;
    text-decoration: underline;
    text-decoration-color: $gray-500;
    line-height: 1;
  }

  @include media-breakpoint-down(sm) {
    &-option {
      display: block;
      margin-bottom: map-get($spacers, 2) !important;
    }
    .el-divider {
      display: none;
    }
  }
}
</style>

<script>
import { Divider } from 'element-ui'

/**
 * Affiche un système de sélection
 */
export default {
  name: 'UbiListSelection',
  components: { ElDivider: Divider },
  props: {
    /**
     * Valeurs sélectionnées
     * @model
     */
    value: Array,
    /**
     * Les sélections possibles, sous la forme d'objets avec value et label
     */
    selections: Array,
    /**
     * Remplace la checkbox par une flèche indiquant que la sélection globale est gérée par le composant positionné au-dessous
     */
    arrowDown: Boolean
  },
  data () {
    return {
      countSelected: false
    }
  },
  // computed: {
  //   countSelected() {
  //     return (this.value && this.value.length);
  //   }
  // },
  methods: {
    onCheckAll (value) {
      if (value) {
        /**
         * Une sélection a été faite (sélectionner tout = "*")
         * @type {string}
         */
        this.countSelected = true
        this.$emit('select', '*')
      } else {
        this.countSelected = false
        this.$emit('input', [])
        this.$emit('select', null)
      }
    }
  }
}
</script>
